import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { BrowserRouter } from 'react-router-dom';  // Keep BrowserRouter here

const root = ReactDOM.createRoot(document.getElementById('root'));
window.getPublicUrl = (path) => `https://admin.abroadbible.net/${path}`;
root.render(
  <Provider store={store}>
    <BrowserRouter basename={'/'}>  
      <App />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
